import { getAppsetting } from '../actions/app';
const {createSlice} = require('@reduxjs/toolkit')
const initialState = {
    reports: {},
    isLoading: false,
    appsetting:[],
  }

  const app = createSlice({
    name: 'app',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(getAppsetting.pending, (state) => {
        state.isLoading = true;
      });
      builder.addCase(getAppsetting.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appsetting = action?.payload 
        console.log(state.appsetting,'state.appsettingstate.appsetting');
      });
      builder.addCase(getAppsetting.rejected, (state) => {
        state.isLoading = false;
      });
      
    },
  });
  
  export default app.reducer;